module.exports = __webpack_public_path__ + "img/subject-pic2.281b3087.png";